import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import DropDown from './dropDown';
import categoryPaths from '../constants/categoryPaths';
import menuPaths from '../constants/menuPaths';

import { ReactComponent as Hamburger } from '../images/svgs/bars-solid.svg';
import styles from '../styles/components/menuNarrowDropDown.module.scss';

const MenuNarrowDropDown = ({ intl }) => {
  const currentLanguage = intl.locale;

  const title = {
    icon: (<Hamburger />),
  };

  const options = [];

  options.push({
    url: currentLanguage,
    messageId: 'menu.home',
  });

  options.push({
    messageId: 'categories.title',
  });

  Object.keys(categoryPaths).forEach((category) => {
    const path = categoryPaths[category][currentLanguage];
    options.push({
      url: `${currentLanguage}/${path}`,
      messageId: `category.${category}`,
      isNested: true,
    });
  });

  const aboutUsPath = menuPaths.aboutUs[currentLanguage];
  options.push({
    url: `${currentLanguage}/${aboutUsPath}`,
    messageId: 'menu.aboutUs',
  });
  const contributePath = menuPaths.contribute[currentLanguage];
  options.push({
    url: `${currentLanguage}/${contributePath}`,
    messageId: 'menu.contribute',
  });

  return (
    <DropDown
      containerStyles={styles.container}
      contentStyles={styles.content}
      nestedStyle={styles.nested}
      options={options}
      title={title}
    />
  );
};

MenuNarrowDropDown.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(MenuNarrowDropDown);
